import { render, staticRenderFns } from "./chair_zhenxin.vue?vue&type=template&id=85eccab2&scoped=true&"
import script from "./chair_zhenxin.vue?vue&type=script&lang=js&"
export * from "./chair_zhenxin.vue?vue&type=script&lang=js&"
import style0 from "./chair_zhenxin.vue?vue&type=style&index=0&id=85eccab2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85eccab2",
  null
  
)

export default component.exports